import * as React from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import { TStockTable } from './StockTable.types';

export const StockTable: TStockTable = ({ items, onEdit }) => {
  const [anchorEl, setAnchorEl] = React.useState<{
    [key: string]: HTMLElement | null;
  }>({});

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    itemId: string
  ) => {
    setAnchorEl({ [itemId]: event.currentTarget });
  };

  const handleMenuClose = (itemId: string) => {
    setAnchorEl((prev) => ({ ...prev, [itemId]: null }));
  };

  const handleEdit = (itemId: string) => {
    const selectedItem = items.find((item) => item.id === itemId);
    if (!selectedItem) return;

    handleMenuClose(itemId);
    onEdit(selectedItem);
  };

  return (
    <div className="entity-table">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ position: 'relative' }}>
              <TableCell className="entity-table__cell">Type</TableCell>
              <TableCell className="entity-table__cell">Name</TableCell>
              <TableCell className="entity-table__cell">Variation</TableCell>
              <TableCell className="entity-table__cell">Quantity</TableCell>
              <TableCell className="entity-table__cell entity-table__cell--actions">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((item) => (
              <TableRow key={item.id} className="entity-table__row">
                <TableCell className="entity-table__cell">
                  {item.type}
                </TableCell>
                <TableCell className="entity-table__cell">
                  {item.name}
                </TableCell>
                <TableCell className="entity-table__cell">
                  {item.variation || '-'}
                </TableCell>
                <TableCell className="entity-table__cell">
                  {item.quantity}
                </TableCell>
                <TableCell className="entity-table__cell entity-table__cell--actions">
                  <IconButton
                    size="small"
                    onClick={(event) => handleMenuOpen(event, item.id)}
                    className="entity-table__menu-button"
                  >
                    <MoreVertIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl[item.id]}
                    open={Boolean(anchorEl[item.id])}
                    onClose={() => handleMenuClose(item.id)}
                  >
                    <MenuItem
                      onClick={() => handleEdit(item.id)}
                      className="entity-table__menu-item"
                    >
                      <EditIcon fontSize="small" sx={{ mr: 1 }} />
                      Edit
                    </MenuItem>
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
